import http from '@/plugins/axios/axios';

export default class EmpresaService { 

    buscarDonoConta(requisicao) {       
        return http.post('/api/usuario/buscar-dono-conta', requisicao);
    }
}